module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [_c('custom-form', [_c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    attrs: {
      "for": "duration"
    }
  }, [_vm._v("Runner Id:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.runner.id),
      expression: "runner.id"
    }],
    ref: "id",
    class: {
      'form-control': true, 'is-danger': _vm.errors.has('id')
    },
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "data-vv-rules": "required",
      "type": "number",
      "name": "id",
      "required": ""
    },
    domProps: {
      "value": (_vm.runner.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.runner, "id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('id')),
      expression: "errors.has('id')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Fill in the Id")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "disabled": !_vm.runner.id
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addRunner()
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--danger",
    attrs: {
      "disabled": !_vm.runner.id
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeRunner()
      }
    }
  }, [_vm._v("Remove")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeCache()
      }
    }
  }, [_vm._v("RemoveCache")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40404621"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/EditRunner.vue
// module id = 1807
// module chunks = 1